import * as React from 'react'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'

const YumTextField = ({ ...props }: TextFieldProps) => {
  return (
    // @ts-ignore: see https://github.com/mui-org/material-ui/issues/7877
    <TextField variant="outlined" margin="normal" required={true} fullWidth={true} {...props} />
  )
}

export default YumTextField
